import _extends from "@babel/runtime/helpers/extends";import _slicedToArray from "@babel/runtime/helpers/slicedToArray";import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";var _excluded = ["children"];import React, { useState, cloneElement, Children } from 'react';
import { InputBar_Root } from './InputBar.style';

/** @type {React.FC<import('@mui/material').PaperProps>} */
export var InputBar = function InputBar(props) {
  var
    children =

    props.children,otherProps = _objectWithoutProperties(props, _excluded);

  var _useState = useState(false),_useState2 = _slicedToArray(_useState, 2),focus = _useState2[0],setFocus = _useState2[1];

  var handleFocus = function handleFocus() {
    setFocus(true);
  };

  var handleBlur = function handleBlur() {
    setFocus(false);
  };

  /**
   * @param {React.ReactElement<any>} child
   */
  function childrenMapper(child) {
    return /*#__PURE__*/cloneElement(child, { focus: focus });
  }

  return /*#__PURE__*/(
    React.createElement(InputBar_Root, _extends({
      elevation: 0,
      focus: focus,
      onBlur: handleBlur,
      onFocus: handleFocus },
    otherProps),

    Children.map(
      /** @type {React.ReactElement<any>} */children,
      childrenMapper
    )
    ));

};
//# sourceMappingURL=InputBar.js.map